import { LegalShell, Section, SUPPORT_EMAIL } from "@/components/LegalShell";

export default function Terms() {
  return (
    <LegalShell
      title="Terms of Service"
      subtitle="The ground rules for using MyPayAlert. By using the service you agree to these terms."
      updated="June 2, 2026"
    >
      <div data-testid="terms-content" className="space-y-8">
        <Section heading="1. Acceptance of terms">
          <p>By creating an account or using MyPayAlert, you agree to these Terms of Service and to our Privacy Policy. If you do not agree, please do not use the service.</p>
        </Section>

        <Section heading="2. What MyPayAlert does">
          <p>MyPayAlert helps you track and estimate your pay, overtime, premiums, deductions, future paychecks and retirement scenarios. All calculations, projections and estimates are provided for planning and informational purposes only.</p>
        </Section>

        <Section heading="3. Estimates are not official figures">
          <p>Pay projections, retirement simulations and pension estimates are approximations based on the information you enter and general assumptions. They are <span className="text-slate-300">not</span> official statements from your employer, payroll department, pension administrator or any government body, and should not be relied upon as financial, tax or legal advice. Always confirm important figures with your employer or a qualified professional.</p>
        </Section>

        <Section heading="4. Your account">
          <p>You are responsible for keeping your login credentials secure and for all activity under your account. You must provide accurate information and be at least 16 years old to use the service.</p>
        </Section>

        <Section heading="5. Subscriptions and billing">
          <p>MyPayAlert offers a free plan and paid (Pro) subscriptions. Paid plans are billed through Stripe on a recurring basis until cancelled. You can cancel at any time from your billing settings; access continues until the end of the current billing period. Prices are shown at checkout and may change with notice.</p>
        </Section>

        <Section heading="6. Acceptable use">
          <ul className="list-disc pl-5 space-y-1.5">
            <li>Don't misuse, disrupt, or attempt to gain unauthorized access to the service.</li>
            <li>Don't upload unlawful content or infringe others' rights.</li>
            <li>Don't resell or reverse-engineer the service without permission.</li>
          </ul>
        </Section>

        <Section heading="7. Your content">
          <p>You keep ownership of the data you enter. You grant us the limited right to store and process it so we can provide the service to you.</p>
        </Section>

        <Section heading="8. Disclaimer of warranties">
          <p>The service is provided "as is" without warranties of any kind. We do not guarantee that calculations will be error-free or that the service will always be available or uninterrupted.</p>
        </Section>

        <Section heading="9. Limitation of liability">
          <p>To the maximum extent permitted by law, MyPayAlert is not liable for any indirect, incidental or consequential damages, or for decisions you make based on estimates produced by the service.</p>
        </Section>

        <Section heading="10. Termination">
          <p>You may stop using MyPayAlert and delete your account at any time. We may suspend or terminate accounts that violate these terms.</p>
        </Section>

        <Section heading="11. Changes to these terms">
          <p>We may update these terms from time to time. Continued use after changes take effect means you accept the updated terms.</p>
        </Section>

        <Section heading="12. Contact">
          <p>Questions about these terms? Email <a href={`mailto:${SUPPORT_EMAIL}`} className="text-blue-400 hover:text-blue-300" data-testid="terms-email">{SUPPORT_EMAIL}</a>.</p>
        </Section>
      </div>
    </LegalShell>
  );
}
